import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { AppSecretKeySchema } from '../../../../widgets/ApplicationSecretKey'

export const resetAppSecretKey = createAsyncThunk<
	AppSecretKeySchema,
	string,
	ThunkConfig<string>
>(
	'resetAppSecretKey',
	async (appId, thunkAPI) => {

		const { extra: { api }, rejectWithValue } = thunkAPI

		try {
			const result = await api.put(`/applications/${appId}/secret`)

			showToast({
				type: 'success',
				toastId: 'resetAppSecretKey',
				message: 'Success'
			})

			return result.data as AppSecretKeySchema
		} catch (e) {
			console.log(e)
			appHandleError(e, 'resetAppSecretKey', 'Failed to reset application secret')
			return rejectWithValue('Error occurred on application secret reset')
		}
	})